module.exports = __webpack_public_path__ + "img/08.eb5bf2ef.jpg";